/**
 * Automatic JavaScript Import System
 * This file uses Vite's glob import to automatically import all JavaScript files
 * from the component structure, eliminating the need for manual imports
 */

// Import core Alpine.js stores first
import './alpine-stores.js';

// Component JavaScript files - import in hierarchical order
const atomScripts = import.meta.glob([
  '../../views/components/atoms/**/*.js',
], { eager: true });

const moleculeScripts = import.meta.glob([
  '../../views/components/molecules/**/*.js',
], { eager: true });

const organismScripts = import.meta.glob([
  '../../views/components/organisms/**/*.js',
], { eager: true });

// Template scripts
const templateScripts = import.meta.glob([
  '../../views/templates/**/*.js',
], { eager: true });

// Global scripts
const globalScripts = import.meta.glob([
  '../../views/global/**/*.js',
], { eager: true });

// Log imported files for debugging (always show during build)
console.log('🚀 JavaScript Files Loaded:');
console.log('Global:', Object.keys(globalScripts));
console.log('Atoms:', Object.keys(atomScripts));
console.log('Molecules:', Object.keys(moleculeScripts));
console.log('Organisms:', Object.keys(organismScripts));
console.log('Templates:', Object.keys(templateScripts));

// Export for potential use in other files
export {
  globalScripts,
  atomScripts,
  moleculeScripts,
  organismScripts,
  templateScripts
};
